import { render, staticRenderFns } from "./StudyPlansTableTermsActiveTerm.vue?vue&type=template&id=793ef10a&"
import script from "./StudyPlansTableTermsActiveTerm.vue?vue&type=script&lang=js&"
export * from "./StudyPlansTableTermsActiveTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports